import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-description">
          Whoops, the page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="cta-button primary">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
